import { useState } from 'react';
import './index.css';
import { Map } from './map';
import { BrowserRouter, Route, Routes } from 'react-router';
import LinePage from './pages/line';
import SearchPage from './pages/search';

type SearchResult = {
	cl: number;
	lc: boolean;
	lt: string;
	sl: number;
	tl: number;
	tp: string;
	ts: string;
	cd: string;
	ct: number;
};

export function App() {
	const [lineSearch, setLineSearch] = useState('');
	const [searchResult, setSearchResult] = useState([] as SearchResult[]);

	const handleSearch = async () => {
		const response = await fetch(
			`/api-proxy/data/Linha/Buscar?termosBusca=${lineSearch}`,
			{ headers: { 'Content-Type': 'application/json' } },
		);
		const data = (await response.json()) as SearchResult[];
		setSearchResult(data);
	};

	return (
		<BrowserRouter>
			<Routes>
				<Route path="/linha" element={<LinePage />} />
				<Route path="/" element={<SearchPage />} />
			</Routes>
		</BrowserRouter>
	);
}

export default App;
